import type { UserSort } from '../types/voip';

export const userSortOptions: { value: UserSort; label: string }[] = [
  { value: 'talk', label: 'Talk time' },
  { value: 'score', label: 'Production score' },
  { value: 'focus', label: 'Focus %' },
  { value: 'answerRate', label: 'Answer rate' },
  { value: 'made', label: 'Calls made' },
  { value: 'answered', label: 'Calls answered' },
  { value: 'missed', label: 'Missed calls' },
  { value: 'avg', label: 'Avg call length' },
  { value: 'name', label: 'Name' },
];
